import {Action} from '@ngrx/store';
import {Client} from '../models/client';
import {type} from '../utilities/type';
import {ServerForm} from '../models/servers';

export const cmsActionTypes = {
  LOAD: type('[CMS] Load'),
  LOAD_SUCCESS: type('[CMS] Load Success'),
  LOAD_FAIL: type('[CMS] Load Fail')
};

export class LoadCMSAction implements Action {
  readonly type = cmsActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor( public payload?:  any) {}
}

export class LoadCMSSuccessAction implements Action {
  readonly type = cmsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ServerForm[]) {}
}

export class LoadCMSFailAction implements Action {
  readonly type = cmsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
